export class SecurityScansSummaryResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "firstInfected",
            "baseName": "firstInfected",
            "type": "SecurityScan",
            "format": ""
        },
        {
            "name": "lastScan",
            "baseName": "lastScan",
            "type": "SecurityScan",
            "format": ""
        },
        {
            "name": "lastClean",
            "baseName": "lastClean",
            "type": "SecurityScan",
            "format": ""
        },
        {
            "name": "infectedSnapshotsCount",
            "baseName": "infectedSnapshotsCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityScansSummaryResponse.attributeTypeMap;
    }
    constructor() {
    }
}
